import { apiClient } from "@lib/axios";
import type {
  LlmPromptsBundle,
  LlmPromptsResponse,
  UpdateLlmPromptsResponse,
} from "./types";

const path = (suffix = "") => `/assets-deployment/llm-prompts${suffix}`;

export const llmPromptsApi = {
  get: (signal?: AbortSignal) =>
    apiClient.get<LlmPromptsResponse>(path(), signal ? { signal } : undefined),

  update: (prompts: LlmPromptsBundle, signal?: AbortSignal) =>
    apiClient.post<UpdateLlmPromptsResponse, { prompts: LlmPromptsBundle }>(
      path(),
      { prompts },
      signal ? { signal } : undefined,
    ),
};
